
let AllShops = () => import('../pages/shop/AllShops')
let ShopRegistration = () => import('../pages/shop/ShopRegistration')
let ShopConfirmation = () => import('../pages/shop/ShopConfirmation')
let ShopLayout = () => import('../pages/shop/ShopLayout')
let ShopDetails = () => import('../pages/shop/ShopDetails')
let ShopCoupons = () => import('../pages/shop/ShopCoupons')
let ShopProducts = () => import('../pages/shop/ShopProducts')
let ProductDetails = () => import('../pages/ProductDetails')


export default [
    {
        path: '/all-shops',
        component: AllShops,
        name: 'AllShops',
        meta: { requiresAuth: true },
    },
    {
        path: '/register-shop',
        component: ShopRegistration,
        name: 'ShopRegistration',
        meta: { requiresAuth: false },
    },
    {
        path: '/register-shop-confirmation',
        component: ShopConfirmation,
        name: 'ShopConfirmation',
        meta: { requiresAuth: false },
    },
    {
        // storage/docs/26-06-25-03-02-거래처URL-슬러그변경-Plan.md
        // 거래처 URL을 /shop/{slug}에서 바닥 경로 /{slug}로 변경. 거래처 슬러그는 가입 시점에
        // 예약어/CMS고정페이지와 안 겹치도록 서버에서 보장하므로(Api/ShopController::shop_register),
        // 여기서는 그냥 바닥 경로로 등록. ShopLayout.vue가 샵이 아니면 CustomPage(CMS 고정페이지)로
        // 위임하므로 이 라우트가 PageRoutes(/:pageSlug?)보다 앞에 와야 함(router.js에서 보장).
        path: "/",
        component: ShopLayout,
        children: [
            {
                path: ':slug',
                component: ShopDetails ,
                name: 'ShopDetails',
                meta: { requiresAuth: true },
            },
            {
                path: ':slug/coupons',
                component: ShopCoupons ,
                name: 'ShopCoupons',
                meta: { requiresAuth: true },
            },
            {
                path: ':slug/products/:categorySlug?',
                component: ShopProducts ,
                name: 'ShopProducts',
                meta: { requiresAuth: true },
            },
            {
                path: ':slug/product/:productSlug',
                component: ProductDetails ,
                name: 'ProductDetails',
                meta: { requiresAuth: true },
            },
        ]
    },
    {
        // 옛 /shop/{slug} 링크 호환(북마크/공유 링크 등) — 새 바닥 경로로 그대로 리다이렉트.
        // storage/docs/26-06-24-07-02-상품URL-shop_id구조변경-Plan.md 의 ProductDetailsRedirect와 동일 패턴.
        path: '/shop/:slug',
        beforeEnter: (to, from, next) => next({ name: 'ShopDetails', params: { slug: to.params.slug }, replace: true }),
    },
    {
        path: '/shop/:slug/coupons',
        beforeEnter: (to, from, next) => next({ name: 'ShopCoupons', params: { slug: to.params.slug }, replace: true }),
    },
    {
        path: '/shop/:slug/products/:categorySlug?',
        beforeEnter: (to, from, next) =>
            next({ name: 'ShopProducts', params: { slug: to.params.slug, categorySlug: to.params.categorySlug }, replace: true }),
    },
    {
        path: '/shop/:slug/product/:productSlug',
        beforeEnter: (to, from, next) =>
            next({ name: 'ProductDetails', params: { slug: to.params.slug, productSlug: to.params.productSlug }, replace: true }),
    },

]
